const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/com/eCheckin/sections/Versicherung.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import textMap from '../translations';
import CIS4mSingleCheckbox from '@cistec/common_web/modules/CIS4m/components/CIS4mSingleCheckbox';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import BehandlungsgrundField from 'App/components/eCheckin/components/fields/metakat/BehandlungsgrundField';
import { VersicherungField } from 'App/components/eCheckin/components/fields/metakat/VersicherungField';
import { VersicherungsdeckungField } from 'App/components/eCheckin/components/fields/metakat/VersicherungsdeckungField';
import { createFieldPath } from 'App/components/eCheckin/utils';
import { useText } from '@cistec/common_web/utils/intlUtils';
import { CIS4mTextField } from '@cistec/common_web/modules/CIS4m/components/CIS4mTextField';

export const Versicherung = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const PATH_BEHANDLUNGSGRUND = createFieldPath(path, 'behandlungsgrund');
    const PATH_VERSICHERUNG = createFieldPath(path, 'versicherungSel');
    const PATH_KLASSE = createFieldPath(path, 'klasse');
    const PATH_ZUSATZVERSICHERUNG = createFieldPath(path, 'zusatzVersicherung');
    const PATH_INSURANCE = createFieldPath(path, 'versicherungName');
    const PATH_INSURANCE_POLICY_NO = createFieldPath(path, 'insurancePolicyNo');
    const PATH_INSURANCE_CARD_NO = createFieldPath(path, 'versichertenKartenNr');

    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <BehandlungsgrundField label={textMap.behandlungsgrund} path={PATH_BEHANDLUNGSGRUND} required={true} />
            <VersicherungField label={textMap.zustVersicherung} path={PATH_VERSICHERUNG} required={true} />
            <VersicherungsdeckungField label={textMap.klasse} path={PATH_KLASSE} required={true} />
            <CIS4mSingleCheckbox label={textMap.zusatzVersicherung} path={PATH_ZUSATZVERSICHERUNG} />
            <CIS4mTextField label={textMap.versicherungName} path={PATH_INSURANCE} required={true} />
            <CIS4mTextField label={textMap.versichertenNr} path={PATH_INSURANCE_POLICY_NO} required={true} />
            <CIS4mTextField
                label={textMap.versichertenKartenNr}
                path={PATH_INSURANCE_CARD_NO}
                required={true}
                mask={'80999999999999999999'}
            />
        </ECheckinSection>
    );
});

Versicherung.displayName = 'Versicherung';

export default Versicherung;
